
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","stroke":"currentColor","stroke-width":"1.5"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"10","cy":"10","r":"9.004"}})])
          )
        }
      }
    